import { FC, PropsWithChildren, useMemo } from 'react'
import { CellProps, Column } from 'react-table'

import { TRANSACTION_DATE_TIME_FORMAT } from 'src/constants/datetimes'
import { IRefillTransaction } from 'src/models/transaction'
import { COLORS } from 'src/shared/theme'
import Table from 'src/shared/views/Table/Table'
import { momentFormat } from 'src/utils/dates'

type RefillsProps = {
  data: IRefillTransaction[]
}

const Refills: FC<RefillsProps> = ({ data }) => {
  const columns = useMemo<Column<IRefillTransaction>[]>(
    () => [
      {
        Header: 'Transaction Date',
        accessor: 'performedAt',
        Cell: ({ row }: CellProps<IRefillTransaction, any>) => (
          <p>
            {momentFormat(
              new Date(row.original.performedAt),
              TRANSACTION_DATE_TIME_FORMAT
            )}
          </p>
        )
      },
      {
        Header: 'Transaction Type',
        disableSortBy: true,
        Cell: () => <p>Debit</p>
      },
      {
        Header: 'Points',
        accessor: 'points',
        disableSortBy: true
      },
      {
        Header: 'Value',
        disableSortBy: true,
        Cell: ({
          row
        }: PropsWithChildren<CellProps<IRefillTransaction, any>>) => (
          <p>${row.original.value.amount.toFixed(2)}</p>
        )
      }
    ],
    []
  )

  return (
    <Table
      columns={columns}
      data={data}
      placeholder="Filter"
      emptyMessage="There are no refills for this program."
      getHeaderProps={() => ({
        style: {
          background: COLORS.white
        }
      })}
    />
  )
}

export default Refills
